angular
  .module 'bookAndPay'
  .controller 'CompleteCtrl', (
    $scope,
    $state,
    DataService
    cart,
  ) ->
    $scope.cart = cart.plain()
    $scope.currency = DataService.currency
    $scope.cartType = if cart.cart_type is 'payment_only_cart'
      'po'
    else
      undefined

    $scope.displayTime = ->
      moment(cart.event_start_at, 'YYYY/MM/DD HH:mma')
        .format('ddd, D MMM [at] h:mm')
